import * as yup from 'yup';
import type { Maybe } from 'yup/lib/types';

export const ucFirst = (str: string): string => {
  if (str.length > 0) {
    return `${str[0].toLocaleUpperCase()}${str.substring(1)}`;
  }

  return str;
};

export const isStringNumber = (str: string): boolean =>
  !Number.isNaN(Number(str));

export const isNoneEmptyString = (str: unknown): str is string => {
  return (
    str !== null && str !== undefined && typeof str === 'string' && str !== ''
  );
};

export const isUpperCase = (str: string): boolean => str.toUpperCase() === str;

export const generateString = (length: number): string => {
  let result = '';
  for (let i = 0; i < length; i += 1) {
    result += 'A';
  }

  return result;
};

export const containsNonAsciiLetters = (text: string): boolean => {
  const textAsArray = text.split('');
  let hasNonAsciiLetter = false;
  textAsArray.forEach((letter) => {
    const code = letter.charCodeAt(0);
    if (code >= 256 && code !== 8364) {
      // 8364 is the char code for "€"
      hasNonAsciiLetter = true;
    }
  });

  return hasNonAsciiLetter;
};

export const testSpecialChars: yup.TestConfig<Maybe<string>, unknown> = {
  name: 'hasSpecialChars',
  message() {
    return 'Enthält Sonderzeichen.';
  },
  test(v) {
    if (v === undefined || v === null) return true;
    return !containsNonAsciiLetters(v);
  },
};
